import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JobBoardRoutingModule } from './job-board-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    JobBoardRoutingModule
  ]
})
export class JobBoardModule { }
